import { UnscanRptService } from '../services';
import { UnscanRptConstants } from '../constants';
import {alertActions} from '.';

export const UnscanRptActions = {
    getAll,
    loadingData,
    exportData
};

function getAll(obj)
{
    return dispatch =>{
        dispatch(request());
        UnscanRptService.fetchUnscanData(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))

            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(successExport(data))
        },
        error => {
            dispatch(failure(error.toString()));
            dispatch(alertActions.error(error.toString()));
        }
        
        );
    };
    function request() { return { type : UnscanRptConstants.GETALL_REQUEST } }
    function success(datas) { return { type: UnscanRptConstants.GETALL_SUCCESS, datas } }
    function successExport(datas) { return { type: UnscanRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: UnscanRptConstants.GETALL_FAILURE, error } }
}

function exportData(obj) {
    return dispatch => {
        dispatch(request());
        UnscanRptService.fetchUnscanData(obj).then(response => {
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(success(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            });
    };
    function request() { return { type: UnscanRptConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: UnscanRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: UnscanRptConstants.GETEXPORT_FAILURE, error } }
}

function loadingData(isbool) {
    return {
        type: UnscanRptConstants.LOADING_REQUEST, isbool
    }
}
